import { fetchApi, ADMIN_API } from '@/api/client'
import type { PipelineTopologyResponse } from '../types/topology'

export async function getPipelineTopology(): Promise<PipelineTopologyResponse> {
  return fetchApi<PipelineTopologyResponse>(`${ADMIN_API}/pipeline/topology`)
}
